import { createError, useRuntimeConfig } from "#app";
import { HttpRequest } from "../utils/HttpRequest.mjs";
export class BaseAuthService {
  config = useRuntimeConfig();
  httpService = new HttpRequest(this.config.public.apiUrl);
  siteUrl = this.config.public.siteUrl;
  constructor() {
    if (!this.config.public.apiUrl || !this.config.public.siteUrl) {
      throw createError({
        statusCode: 500,
        statusMessage: "\u0414\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0435\u0440\u0432\u0438\u0441\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438 \u0432 runtimeConfig \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0443\u043A\u0430\u0437\u0430\u043D siteUrl \u0438 apiUrl"
      });
    }
  }
  /**
   * Получение ссылок для авторизации и разлогина;
   *
   * @param {IAuthClientGetLinksRequest} data - данные для совершения запроса
   */
  async getAuthLinks(data) {
    return await this.httpService.get(`/v1/auth/get-links`, {
      query: {
        redirect_uri: data.redirect_uri ? this.siteUrl + data.redirect_uri : this.siteUrl,
        service_id: data.service_id
      }
    });
  }
  /**
   * Получение сессии;
   *
   * @param {IAuthClientSetSessionRequest} data - данные для совершения запроса
   */
  async getSession(data) {
    return await this.httpService.post(
      "/v1/auth/set-session",
      {
        session_state: data.session_state,
        code: data.code,
        pass_entrance: data.pass_entrance,
        redirect_uri: data.redirect_uri ? this.siteUrl + data.redirect_uri : this.siteUrl,
        fetch_access_roles: data.fetch_access_roles ?? true,
        fetch_profile_data: data.fetch_profile_data ?? true,
        service_id: data.service_id
      },
      {
        credentials: "include"
      }
    );
  }
  /**
   * Получение текущего юзера;
   */
  async getCurrent() {
    return await this.httpService.get("/v1/auth/current", { credentials: "include" });
  }
}
